import Vue from 'vue'
import App from './App.vue'
import AllSilderPc from '@/base/allSilder/allSilderPc.vue'
import AllSilderH5 from '@/base/allSilder/allSilderH5.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'
import autoSize from 'common/js/auto-size'
import fastclick from 'fastclick'
import MetaInfo from 'vue-meta-info'
import Viewer from 'v-viewer'
import VueTouch from 'vue-touch'
import skeleton from 'vue-skeleton-component'
import infiniteScroll from "vue-infinite-scroll"
// import VueLazyLoad from 'vue-lazyload'

import {customerInfo} from 'common/js/loginInfo'
import $ from 'jquery'
import {getQueryParams} from 'common/js/tools'
import './plugin/element.js'
import 'element-ui/lib/theme-chalk/index.css'
// import Element from 'element-ui'
import 'viewerjs/dist/viewer.css'


import './plugin/vant.js'
import {Rate, Sticky, Switch, NoticeBar, CountDown, ActionSheet, PullRefresh, List} from 'vant'

import {getMPJSAPIData} from './api/api'

Vue.use(Rate).use(Sticky).use(Switch).use(NoticeBar).use(CountDown).use(ActionSheet).use(PullRefresh).use(List)

import {ImagePreview} from 'vant'
Vue.use(infiniteScroll)
Vue.use(skeleton)
Vue.use(ImagePreview)
Vue.config.productionTip = false
Vue.use(Viewer);
Viewer.setDefaults({
  Options: {
    "inline": true,
    "button": true,
    "navbar": true,
    "title": true,
    "toolbar": true,
    "tooltip": true,
    "movable": true,
    "zoomable": true,
    "rotatable": true,
    "scalable": true,
    "transition": true,
    "fullscreen": true,
    "keyboard": true,
    "url": "data-source"
  }
});

Vue.use(VueTouch, {name: 'v-touch'})

// Vue.use(Element)
Vue.use(MetaInfo)
fastclick.attach(document.body)
Vue.use(autoSize)
// Vue.use(VueLazyLoad,{
//   error: require('./common/images/vlazyload/lazyload.png'),
//   loading: require('./common/images/vlazyload/lazyload.png')
// })
/* eslint-disable no-unused-vars */

// 打开Console测试
// import VConsole from 'vconsole'
// const vConsole = new VConsole()
// export default vConsole

let wx = require('weixin-js-sdk')

router.beforeEach((to, from, next) => {
    if (to.matched.length === 0) { // 如果未匹配到路由
        from.name ? next({name: from.name}) : next('/m/error504') // 如果上级也未匹配到路由则跳转登录页面，如果上级能匹配到则转上级路由
    } else {
        //需要提前把首次访问的原始url记录下来
        // initWXConfigByIOS()
        // setIOSParams(to)
        //如果是iOS并且是微信浏览器，先做Url处理 20201226增加处理，测试有效
        //参考：https://www.cnblogs.com/zishang91/p/10755488.html
        let ua = window.navigator.userAgent.toLowerCase()
        if (/micromessenger/.test(ua) && window.__wxjs_is_wkwebview) {
            let FRONT_BASE = `${location.protocol}//${location.host}`
            let url = FRONT_BASE + to.fullPath
            if (window.entryUrl === '' || window.entryUrl === undefined || window.entryUrl === null) {
                window.entryUrl = url
            }
            // console.log('window.entryUrl',window.entryUrl)
            // console.log('url',url)
            if (window.entryUrl !== url) {
                window.entryUrl = url
                window.location.replace(url)
            } else {
                getWXConfig(window.entryUrl)
            }
        }
        if (to.query.chid) {
            sessionStorage.setItem('channelid', to.query.chid)
            store.commit('SET_CHANNELID', to.query.chid)
        }
        let cookiearr = document.cookie.split('; ')
        let cookieitemarr = []
        let cookieobj = {}
        cookieitemarr = cookiearr.map((item) => {return item.split('=')})
        cookieitemarr.forEach((item) => {
            cookieobj[item[0]] = item[1]
        })
        if (to.query.token === '') {
          let params = getQueryParams()
          delete params.token
          next({name: to.name, query: params})
        } else if (to.query.token) {
            let user = $.extend({}, store.state.user)
            let params = getQueryParams()
            if (user.loginToken != to.query.token || !user.innerid) {
                user.loginToken = to.query.token
                sessionStorage.setItem('user', JSON.stringify(user))
                store.commit('SET_USER', user)
                customerInfo(user, function() {
                    delete params.token
                    delete params.expiretime
                    next({name: to.name, query: params})
                })
            } else {
                delete params.token
                delete params.expiretime
                next({name: to.name, query: params})
            }
        } else {
            if (document.cookie.indexOf('token') !== -1) {
                const cookiesArr = document.cookie.split('; ')
                let tokenArr = ''
                let tokenIndex = 0
                cookiesArr.some((item, index) => {
                    if (item.indexOf('token') !== -1) {
                        tokenArr = item.split('=')
                        tokenIndex = index
                        return true
                    }
                })
                const sessionToken = store.state.user ? store.state.user.loginToken : ''
                if (tokenArr[1] && (!sessionToken || tokenArr[1] !== sessionToken)) {
                    store.commit('SET_USER', {loginToken: tokenArr[1]})
                    customerInfo({loginToken: tokenArr[1]})
                    next() // 如果匹配到正确跳转
                } else {
                    // let exp = new Date();//获取客户端本地当前系统时间
                    // exp.setTime(exp.getTime() - 60 * 1000);//将exp设置为客户端本地时间1分钟以前，将exp赋值给cookie作为过期时间后，就表示该cookie已经过期了, 那么浏览器就会将其立刻删除掉
                    // document.cookie = cookiesArr[tokenIndex] + ";expires=" + exp.toUTCString();
                    next() // 如果匹配到正确跳转
                }
            } else {
                let user = {
                    innerid: '',
                    isperfect: '',
                    loginToken: '',
                    loginname: '',
                    logourl: '',
                    mobile: '',
                    name: '',
                    nickname: '',
                    promoterid: '',
                    isLogin: false,
                    zjmemtype: 0
                }
                sessionStorage.setItem('user', JSON.stringify(user))
                store.commit('SET_USER', user)
                next() // 如果匹配到正确跳转
            }
        }
    }
})
Vue.component('AllSilderPc', AllSilderPc)
Vue.component('AllSilderH5', AllSilderH5)
// 忽略自定义标签
Vue.config.ignoredElements = [
    'wx-open-launch-app',
    'wx-open-launch-weapp'
]
new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')


function setIOSParams(to) {
  // 微信浏览器
  //https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#%E9%99%84%E5%BD%951-JS-SDK%E4%BD%BF%E7%94%A8%E6%9D%83%E9%99%90%E7%AD%BE%E5%90%8D%E7%AE%97%E6%B3%95
  let ua = window.navigator.userAgent.toLowerCase()
  if (/micromessenger/.test(ua)) {
    // 授权后可能要去掉token和expiretime才行
    // 然后分享的方法写到自己的每个页面试试看
    if (window.__wxjs_is_wkwebview) { // IOS
        let params = getQueryParams()
        delete params.token
        delete params.expiretime
        let len = Object.keys(params).length
        let str = ''
        if (len > 0) {
            str = '?'
            for (var i in params) {
                str += i + '=' + params[i] + '&'
            }
            str = str.substring(0, str.length - 1)
        }
        if (window.entryUrl === '' || window.entryUrl === undefined) {
            window.entryUrl = window.location.protocol + '//' + window.location.host + to.path + str// 将后面的参数去除
            // window.entryUrl=location.href.split('#')[0]
        }
    }
    // console.log('entryUrl',window.entryUrl)
  }
}

//ios下初始化config
function getWXConfig(url){
    //初始化config
    getMPJSAPIData({
        data: {
            url: encodeURIComponent(url)
        },
        success: data => {
            // console.log('data',data)
            let wxParams = data.data
            wx.config({
                debug: false,
                appId: wxParams.appid,
                timestamp: wxParams.timestamp,
                nonceStr: wxParams.noncestr,
                signature: encodeURIComponent(wxParams.signature),
                jsApiList: [
                    'onMenuShareAppMessage', // 1.0 分享到朋友
                    'onMenuShareTimeline', // 1.0分享到朋友圈
                    'updateAppMessageShareData', // 1.4 分享到朋友
                    'updateTimelineShareData' // 1.4分享到朋友圈
                ]
            }),
            wx.error(function(res){
                // console.log('wx.error',res)                
            }) 
        },
        error: data => {
            // console.log('data.error',data)
        }
    })
}